import homeRoutes from './home';
import manageRoutes from './manage';
import orderRoutes from './order';
import pickGoodsRoutes from './pickGoods';
import statisticRoutes from './statistic';
import userCenterRoutes from './userCenter';
import goodManageRoutes from './goodManage';
import authManageRoutes from './authManage';
import mobileRoutes from './mobile';
import authBindRoutes from './authBindRoutes';
import settlementRoutes from './settlementRoutes';
import marketingRoutes from './marketing';
import messageCenterRoutes from './messageCenter';
import announcement from './announcement';
import framework from '@/common/layout/index';
import pageWelcome from '@/pages/welcome/index';

export const routes = [{
  path: '/index',
  name: 'index',
  component: framework, // 框架组件，与app.js一起打包，加速初始化渲染（带登录态）
  redirect: () => 'pickGoods',
  children: [].concat(
    homeRoutes,
    manageRoutes,
    orderRoutes,
    pickGoodsRoutes,
    statisticRoutes,
    userCenterRoutes,
    authManageRoutes,
    goodManageRoutes,
    settlementRoutes,
    marketingRoutes,
    messageCenterRoutes,
    announcement,
  ),
},
...mobileRoutes,
...authBindRoutes,
{
  path: '/welcome',
  name: 'welcome',
  component: pageWelcome, // 与app.js一起打包，加速初始化渲染（不带登录态）
  meta: {
    auth: 'noAuth',
    spm: 2076,
  },
},
{
  path: '/login',
  name: 'login',
  meta: {
    auth: 'noAuth',
    pageId: 10006,
    spm: 2063,
  },
  component: () => import(/* webpackChunkName: "login" */'@/pages/loginV2/index'),
},
{
  path: '/transfer',
  name: 'transfer',
  meta: {
    auth: 'noAuth',
    spm: 2261,
  },
  component: () => import('@/pages/login/transfer'),
},
{
  path: '/transit',
  name: 'transit',
  meta: {
    auth: 'noAuth',
    spm: 2446,
  },
  component: () => import('@/pages/transit/index'),
},
{
  path: '/register',
  name: 'register',
  meta: {
    auth: 'noAuth',
    spm: 2064,
  },
  component: () => import('@/pages/registerv2/index'),
},
{
  path: '/bindResult',
  name: 'bindResult',
  component: () => import('@/pages/bind/index'),
  meta: {
    spm: 2262,
  },
},
{
  path: '/mediaBindResult',
  name: 'mediaBindResult',
  component: () => import('@/pages/mediaBind/index'),
  meta: {
    spm: 2263,
  },
},
{
  path: '/invite',
  name: 'invitePage',
  component: () => import('@/pages/invite/index'),
  meta: {
    auth: 'noAuth',
    spm: 2264,
  },
},
{
  path: '/applying',
  name: 'applyingPage',
  component: () => import('@/pages/applying/index'),
  meta: {
    auth: 'noAuth',
    spm: 2265,
  },
},
{
  path: '/applyResult/:status',
  name: 'applyResult',
  component: () => import('@/pages/applyResult/index'),
  meta: {
    auth: 'noAuth',
    spm: 2266,
  },
},
{
  path: '/404',
  name: '404',
  component: () => import('@/pages/notFound/index'),
  meta: {
    spm: 2267,
  },
},
{
  path: '/noAuth',
  name: 'noAuth',
  component: () => import('@/pages/noAuth/index'),
  meta: {
    spm: 2268,
  },
},
{
  path: '/',
  // 方法接收目标路由作为参数
  redirect: () => 'userCenter',
},
{
  path: '*',
  redirect: '404',
},
];
